import { addOnClosestListener } from '../general/helpers';

export default function headerController() {
  const header = document.querySelector('.header');

  addOnClosestListener('click', '.header .header-burger', (burger, event) => {
    header.classList.toggle('menu-open');

    burger.classList.toggle('menu-open');

    if (header.classList.contains('menu-open')) {
      document.body.classList.add('menu-open', 'overflow-hidden');
    } else {
      document.body.classList.remove('menu-open', 'overflow-hidden');
    }
  });

  selectedProductsSwiper();
  fixCartCountBubble();

  function fixCartCountBubble() {
    document.addEventListener('cart:updated', function () {
      const cartCountBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');

      if (!cartCountBubble) {
        return;
      }

      const cartCount = cartCountBubble.querySelector('span[aria-hidden="true"]');
      const visuallyHiddenCartCount = cartCountBubble.querySelector('span.visually-hidden');

      cartCountBubble.classList.toggle('hidden', !cartCount || +cartCount.textContent == 0);

      if (visuallyHiddenCartCount && cartCount && +cartCount.textContent < 100) {
        visuallyHiddenCartCount.textContent = visuallyHiddenCartCount.textContent.replace(
          /\d+/,
          +cartCount.textContent
        );
      }
    });
  }

  function selectedProductsSwiper() {
    const selectedProductsSwiperElement = document.querySelector('.header__selected-products.swiper');

    if (!selectedProductsSwiper) {
      return;
    }

    const swiper = new Swiper(selectedProductsSwiperElement, {
      slidesPerView: 2,
      spaceBetween: 5,
      breakpoints: {
        568: {
          slidesPerView: 3,
          spaceBetween: 12,
        },
      },
    });
  }

  function toggleSubmenu(parent) {
    const submenu = parent?.querySelector('.new-header-menu-submenu');

    if (!submenu) {
      console.warn('No submenu found for the clicked item');
      return;
    }

    const submenuInner = submenu.querySelector('.new-header-menu-submenu__inner');
    if (submenuInner) {
      submenuInner.style.overflow = 'hidden';
    }

    parent.classList.toggle('submenu-opened');

    if (header) {
      header.classList.toggle('submenu-opened');
    }
  }

  addOnClosestListener('click', '.new-header-menu-item__after, .new-header-menu-item[href="#"]', (target, event) => {
    event.preventDefault();

    const parent = target.closest('.has-submenu');
    parent && toggleSubmenu(parent);
  });

  document.querySelectorAll('.new-header-menu-item-wrapper.submenu-opened').forEach((submenu) => {
    const inner = submenu.querySelector('.new-header-menu-submenu__inner');
    if (inner) {
      inner.style.overflow = 'unset';
    }
  });

  document.querySelectorAll('.new-header-menu-submenu').forEach((submenu) => {
    submenu.addEventListener('transitionend', (event) => {
      const parent = submenu.closest('.has-submenu');
      if (parent && parent.classList.contains('submenu-opened')) {
        const inner = submenu.querySelector('.new-header-menu-submenu__inner');
        if (inner) {
          inner.style.overflow = 'unset';
        }
      }
    });
  });

  const newHeaderMenu = document.querySelector('.new-header-menu');
  if (newHeaderMenu) {
    setTimeout(() => {
      newHeaderMenu.style.removeProperty('display');
    }, 1000);
  } //TODO: Remove when all site opmimization will be applied

  // document.querySelector('.header-burger')?.click();
}
